import { ReactNode } from "react";

import { Tooltip } from "_/components/tooltip";

type BuildsetTooltipProps = {
  children: ReactNode;
  value?: string;
  fullName?: string;
  id?: string;
};

export const BuildsetTooltip = ({
  children,
  value,
  fullName,
  id,
}: BuildsetTooltipProps) => {
  if (!id) return <>{children}</>;

  const tooltip =
    fullName && value && fullName !== value ? `${fullName}\n${id}` : id;
  const target = <span>{children}</span>;

  return (
    <Tooltip
      placement="top"
      target={target}
      content={<span style={{ whiteSpace: "pre-wrap" }}>{tooltip}</span>}
      delay={200}
      wait={200}
    />
  );
};
